import React from "react";
import { connect } from "react-redux";

import { withRouter } from "react-router-dom";
import PreOrderList from "../../shared/pre-order/pre-order-list";
import usePreOrder from "./usePreOrder";

const AgentPreOrderListPage = ({ userData, dispatch }) => {
  const {
    modalStates,
    requestApprovePreOrder,
    handleConfirmCancelPreOrder,
    handleDownloadPredOrder,
    handleResetCancelState,
    handleResetApprovalState,
  } = usePreOrder(dispatch);

  return (
    <PreOrderList
      userData={userData}
      preOrderOnCancelFinished={modalStates.cancel.finished}
      loadingPreOrderOnCancelDialog={modalStates.cancel.loading}
      handleConfirmCancelPreOrder={handleConfirmCancelPreOrder}
      requestApprovePreOrder={requestApprovePreOrder}
      preOrderOnApprovalFinished={modalStates.approve.finished}
      loadingPreOrderOnApprovalDialog={modalStates.approve.loading}
      handleDownloadPreOrder={handleDownloadPredOrder}
      handleResetCancelState={handleResetCancelState}
      handleResetApprovalState={handleResetApprovalState}
    />
  );
};

const mapStateToProps = (data) => data;

export default connect(mapStateToProps)(withRouter(AgentPreOrderListPage));
